<div
  #container
  class="relative w-full max-w-[600px] aspect-square mx-auto flex items-center justify-center perspective-[1000px]"
>
  <!-- Monolith Element -->
  <svg
    #monolith
    class="w-64 h-64 md:w-80 md:h-80 drop-shadow-[0_0_40px_rgba(255,49,216,0.4)] relative z-10"
    viewBox="0 0 250 250"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="leftGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stop-color="#FF31D8" />
        <stop offset="100%" stop-color="#FF1493" />
      </linearGradient>
      <linearGradient id="rightGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stop-color="#E335FF" />
        <stop offset="100%" stop-color="#5B30FF" />
      </linearGradient>
      <linearGradient id="centerGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stop-color="#FF31D8" />
        <stop offset="100%" stop-color="#E335FF" />
      </linearGradient>
      <linearGradient id="bottomGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stop-color="#FF1493" />
        <stop offset="100%" stop-color="#B01030" />
      </linearGradient>
    </defs>

    <!-- Left Triangle Base & Facets -->
    <path d="M 101 28 L 34 58 L 45 162 Z" fill="url(#leftGrad)" />
    <path d="M 101 28 L 34 58 L 65 80 Z" fill="white" opacity="0.35" />
    <path d="M 34 58 L 45 162 L 65 80 Z" fill="black" opacity="0.2" />

    <!-- Right Triangle Base & Facets -->
    <path d="M 149 28 L 216 58 L 205 162 Z" fill="url(#rightGrad)" />
    <path d="M 149 28 L 216 58 L 185 80 Z" fill="white" opacity="0.35" />
    <path d="M 216 58 L 205 162 L 185 80 Z" fill="black" opacity="0.25" />

    <!-- Center Triangle Base & Facets -->
    <path d="M 125 76 L 153 143 L 97 143 Z" fill="url(#centerGrad)" />
    <path d="M 125 76 L 97 143 L 125 115 Z" fill="white" opacity="0.25" />
    <path d="M 97 143 L 153 143 L 125 115 Z" fill="black" opacity="0.2" />

    <!-- Bottom Hexagon Base & Facets -->
    <path
      d="M 87 166 L 163 166 L 175 196 L 125 224 L 75 196 Z"
      fill="url(#bottomGrad)"
    />
    <path d="M 87 166 L 163 166 L 125 185 Z" fill="white" opacity="0.25" />
    <path d="M 125 224 L 75 196 L 125 185 Z" fill="black" opacity="0.3" />
    <path d="M 175 196 L 125 224 L 125 185 Z" fill="black" opacity="0.15" />
    <path d="M 75 196 L 87 166 L 125 185 Z" fill="white" opacity="0.1" />

    <!-- Crystal Edges / Wireframe Glow -->
    <g
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      opacity="0.4"
      fill="none"
    >
      <path d="M 101 28 L 65 80 L 34 58 M 65 80 L 45 162" />
      <path d="M 101 28 L 34 58 L 45 162 Z" />
      <path d="M 149 28 L 185 80 L 216 58 M 185 80 L 205 162" />
      <path d="M 149 28 L 216 58 L 205 162 Z" />
      <path d="M 125 76 L 125 115 L 97 143 M 125 115 L 153 143" />
      <path d="M 125 76 L 153 143 L 97 143 Z" />
      <path
        d="M 87 166 L 125 185 L 163 166 M 75 196 L 125 185 L 175 196 M 125 224 L 125 185"
      />
      <path d="M 87 166 L 163 166 L 175 196 L 125 224 L 75 196 Z" />
    </g>
  </svg>

  <!-- Orbital Badges Group -->
  <div #orbitalGroup class="absolute inset-0 z-20 pointer-events-none">
    @if (!isMobile()) {
    <!-- Desktop orbital badges -->
    <div
      #badgeBr
      data-orbital-label
      class="absolute top-[22%] left-[15%] md:left-[12%] px-4 py-2 rounded-xl backdrop-blur-md bg-white/5 border border-yellow-500/50 text-white font-bold text-sm shadow-[0_0_15px_rgba(250,204,21,0.3)] pointer-events-auto transform transition-transform hover:scale-105"
    >
      1ª do Brasil
      <span class="ml-2">
        <img
          class="w-4 h-4 inline"
          src="images/home/flag-for-flag-brazil-svgrepo-com.svg"
          alt="Bandeira do Brasil"
        />
      </span>
    </div>

    <div
      data-orbital-label
      class="absolute top-[18%] right-[15%] md:right-[12%] px-4 py-2 rounded-xl backdrop-blur-md bg-white/5 border border-white/10 text-white font-medium text-sm shadow-[0_4px_12px_rgba(0,0,0,0.5)] pointer-events-auto transform transition-transform hover:scale-105"
    >
      <span class="mr-2">⚡</span> Angular 22+
    </div>

    <div
      data-orbital-label
      class="absolute bottom-[18%] right-[22%] md:right-[18%] px-4 py-2 rounded-xl backdrop-blur-md bg-white/5 border border-white/10 text-white font-medium text-sm shadow-[0_4px_12px_rgba(0,0,0,0.5)] pointer-events-auto transform transition-transform hover:scale-105"
    >
      <span class="mr-2">✨</span> Nx
    </div>

    <div
      data-orbital-label
      class="absolute bottom-[25%] left-[15%] md:left-[12%] px-4 py-2 rounded-xl backdrop-blur-md bg-white/5 border border-white/10 text-white font-medium text-sm shadow-[0_4px_12px_rgba(0,0,0,0.5)] pointer-events-auto transform transition-transform hover:scale-105"
    >
      <span class="mr-2">🤖</span> AI Agents
    </div>

    <div
      data-orbital-label
      class="absolute bottom-[35%] right-[12%] md:right-[0%] px-4 py-2 rounded-xl backdrop-blur-md bg-white/5 border border-white/10 text-white font-medium text-sm shadow-[0_4px_12px_rgba(0,0,0,0.5)] pointer-events-auto transform transition-transform hover:scale-105"
    >
      <span class="mr-2">🏗️</span> Arquitetura Enterprise
    </div>

    <div
      data-orbital-label
      class="absolute top-[7%] left-[30%] px-2 py-1 rounded-full backdrop-blur-sm bg-white/5 border border-white/5 text-gray-300 text-xs shadow-lg"
    >
      • Signals
    </div>

    <div
      data-orbital-label
      class="absolute bottom-[8%] left-[35%] px-2 py-1 rounded-full backdrop-blur-sm bg-white/5 border border-white/5 text-gray-300 text-xs shadow-lg"
    >
      • Signal Forms
    </div>

    <div
      data-orbital-label
      class="absolute top-[45%] right-0 md:right-10 px-2 py-1 rounded-full backdrop-blur-sm bg-white/5 border border-white/5 text-gray-300 text-xs shadow-lg"
    >
      • SSR
    </div>
    }
  </div>
</div>
